module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-9@3x.ed28aefd.png";